import { FC } from 'react';
import styled from 'styled-components';
import { Subtitle1 } from 'ui/theme';
import { CompleteQuery } from 'modules/queryBuilder/types';
import {
  BREAKDOWN_AUDIENCE_LIFT,
  BREAKDOWN_VIEW_IN_SEGMENTATION,
} from 'modules/intelligentInsights/constants';
import { BUTTON_VARIANTS, BUTTON_SIZES } from 'ui/button';
import { Body2Medium, colors, spacing } from 'ui/theme';
import { FlexSpacer } from 'ui/flexSpacer';
import { Open24 } from 'ui/icons';
import { SegmentationLinkButton } from 'modules/segmentation/navigation';

export const Header = styled(Subtitle1)`
  margin: 0;
`;

const MarginlessBody2Medium = styled(Body2Medium)`
  margin: 0;
`;

const SpacingSegmentationLinkButton = styled(SegmentationLinkButton)`
  margin-right: ${spacing.plusHalf};
`;

export const BREAKDOWN_VIEW_IN_SEGMENTATION_ID = 'breakdown-view-in-segmentation';

export type AudienceLiftHeaderProps = {
  searchQuery?: CompleteQuery;
};

export const AudienceLiftHeader: FC<AudienceLiftHeaderProps> = ({ searchQuery }) => {
  const showLowerPriorityFeature = false;
  return (
    <FlexSpacer flexDirection="column" alignItems="start" justifyContent="center">
      <Header>{BREAKDOWN_AUDIENCE_LIFT}</Header>
      {showLowerPriorityFeature && (
        <SpacingSegmentationLinkButton
          data-test={BREAKDOWN_VIEW_IN_SEGMENTATION_ID}
          searchQuery={searchQuery}
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.SECONDARY}
        >
          <MarginlessBody2Medium>{BREAKDOWN_VIEW_IN_SEGMENTATION}</MarginlessBody2Medium>
          <Open24 color={colors.iconSubtle} />
        </SpacingSegmentationLinkButton>
      )}
    </FlexSpacer>
  );
};
